import { URI_FINANCIAL_ACCOUNT } from '@/config/config';

export default async ({ rootState }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const path = `${URI_FINANCIAL_ACCOUNT}creditors`;

  const response = await fetch(path, opts);

  const jsonResult = await response.json();

  if (jsonResult.status === 'error') {
    return Promise.reject(jsonResult.message);
  }
  return jsonResult.data;
};
